angular
    .module('app.controllers')
    .controller('ShowProjectCtrl', function ($rootScope, $scope, $stateParams, $state, $translate, notify, api, formValidator, UserService, variables) {
        // dane
        const ProjectModel = api('projects');

        $scope.clientOptions = [];
        $scope.relatedInterest = null;
        $scope.areAllPhasesClosed = true;
        $scope.project = {};
        $scope.investments = [];
        $scope.investmentOptions = [];

        api('investments')
            .list()
            .then((response) => {
                $scope.investments = response.data;
            });

        $scope.$watch('project.client_id', (client_id) => {
            $scope.updateInvestments(client_id);
        });

        $scope.updateInvestments = function (client_id) {
            if (!client_id) {
                $scope.project.investment_id = 0;
                $scope.investmentOptions = [];
            } else {
                $scope.investmentOptions = $scope.investments
                    .filter((investment) => investment.client_id == $scope.project.client_id)
                    .map((investment) => ({
                        value: investment.id,
                        label: investment.name,
                    }));
            }
        };

        $scope.isDisabled = false;
        if (0 < $stateParams.id) {
            const info = notify.info($translate.instant('loading'));
            $scope.isDisabled = true;
            ProjectModel.get($stateParams.id).then((response) => {
                $scope.project = response;
                $scope.relatedInterest = $scope.project.interest;

                $scope.clientOptions = [
                    {
                        id: $scope.project.client_id,
                        name: $scope.project.client.name,
                    },
                ];

                angular.forEach($scope.project.phases || [], (phase) => {
                    if (phase.status_id != variables.defaults.phase_status_closed) {
                        $scope.areAllPhasesClosed = false;
                    }
                });

                info.close();
                notify.success($translate.instant('loaded'));
                $rootScope.$broadcast('edit-panel-ready');
            });
        } else {
            $scope.project = {
                id: 0,
                type: $stateParams.type || 'measurement',
                author_id: UserService.getUser().id,
                owner_id: UserService.getUser().id,
                status_id: variables.defaults.project_status_started,
            };

            if ($stateParams.client) {
                api('clients')
                    .get($stateParams.client)
                    .then((response) => {
                        $scope.clientOptions.push({
                            id: response.id,
                            name: response.name,
                        });
                        $scope.project.client_id = $stateParams.client;
                    });
            }

            if ($stateParams.interest) {
                api('interests')
                    .get($stateParams.interest)
                    .then((response) => {
                        $scope.relatedInterest = response;
                        $scope.project.related_interest_id = $stateParams.interest;
                    });
            }
        }

        $scope.statusOptions = [];
        api('dictionaries/project_status')
            .selectize()
            .then((response) => {
                $scope.statusOptions = response.data;
            });

        // blokowanie przed zakończeniem zlecenia, jeżeli etapy nie są jeszcze gotowe
        $scope.$watch('project.status_id', (value) => {
            if (value == variables.defaults.project_status_closed && !$scope.areAllPhasesClosed) {
                $scope.project.status_id = null;
                notify.danger($translate.instant('projects.not_all_phases_ready'));
            }
        });

        $scope.typeOptions = [
            { value: 'measurement', label: $translate.instant('projects.measurement') },
            { value: 'installation', label: $translate.instant('projects.installation') },
            { value: 'transport', label: $translate.instant('projects.transport') },
            { value: 'service', label: $translate.instant('projects.service') },
        ];

        $scope.userOptions = [];
        api('users')
            .selectize({ transform: { id: 'id', value: ':fullname (:job.value)' } })
            .then((response) => {
                $scope.userOptions = response.data;
            });

        // form validation
        const fv = formValidator('#ProjectForm', $scope);

        $scope.saveProject = () => {
            if (!fv.isValid()) {
                return;
            }

            const redirectAfterSave = 0 == $scope.project.id;
            const info = notify.info($translate.instant('saving'));
            notify.global(1);

            ProjectModel.save($scope.project.id, $scope.project).then((response) => {
                $scope.project = response;
                ProjectModel.clearCache();

                info.close();
                notify.success($translate.instant('saved'));
                notify.global(0);
                $rootScope.$broadcast('edit-panel-ready');

                if (redirectAfterSave) {
                    $state.go('restricted.projects_edit', { id: $scope.project.id });
                }
            });
        };

        $scope.showPhases = false;
        $scope.setTab = (tab) => {
            $scope.showPhases = 2 == tab;
        };
    });
